import React from "react";
import { Radar } from "react-chartjs-2";
import { Chart as ChartJS, RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend } from "chart.js";

// Register necessary Chart.js components
ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

export default function RadarChart() {
  const data = {
    labels: ["Extraversion", "Agreeableness", "Conscientiousness", "Neuroticism", "Openness to Experience"],
    datasets: [
      {
        label: "Player Stats",
        data: [8,20,18,20,10],
        backgroundColor: "rgba(54, 162, 235, 0.2)",
        borderColor: "rgba(54, 162, 235, 1)",
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    scales: {
        r: {
          suggestedMin: 0, // Optional: Set a minimum value
          suggestedMax: 20, // Set the maximum value for the chart
          ticks: {
            stepSize: 5, // Optional: Control the spacing between tick marks
          },
        },
      },
    plugins: {
      legend: {
        display: false,
      },
    },
  };

  return <Radar data={data} options={options} />;
};